type TBoards =
|'name'
|'black'
;
const BoardsNS = 'boards';
function BoardsF(_: TBoards): string { return `${BoardsNS}:${_}`; }
export {BoardsF,BoardsNS,TBoards};
